export enum ErrorType {
    SEND_GENERIC_ERROR = "send",
    SAVE_GENERIC_ERROR = "save",
    SEND_VALIDATION_ERROR = "validation_send",
    SAVE_VALIDATION_ERROR  = "validation_save"
}